export default __webpack_public_path__ + "static/img1-c20f91a19d015c929841cacd3ac87adb.jpg";